import React from 'react';

import { CollapsibleBlock } from '../components';

const titleStyles = {
  textAlign: 'center',
  marginBottom: '2rem',
  marginTop: '4rem',
};

const FAQsSection = ({ data: { collapsibleBlock, title, displayTitle } }) => (
  <div id="FAQ">
    <div className="container">
      {title && displayTitle && <h2 style={titleStyles}>{title}</h2>}
      <div className="w-layout-grid faq-grid">
        {collapsibleBlock.map((block) => (
          <CollapsibleBlock data={block} key={block.title} />
        ))}
      </div>
    </div>
  </div>
);

export { FAQsSection };
